import * as XLSX from 'xlsx';

/**
 * Export data to an Excel (.xlsx) file.
 * @param {Array<Object>} data - Array of row objects.
 * @param {Array<{header: string, key: string}>} columns - Column definitions with header label and data key.
 * @param {string} filename - Name for the downloaded file (without extension).
 */
export const exportToExcel = (data, columns, filename = 'export') => {
    // Build header row
    const headers = columns.map(c => c.header);

    // Build data rows
    const rows = data.map(row =>
        columns.map(c => {
            const value = c.key.split('.').reduce((obj, key) => obj?.[key], row);
            return value ?? '';
        })
    );

    // Create worksheet
    const wsData = [headers, ...rows];
    const ws = XLSX.utils.aoa_to_sheet(wsData);

    // Auto-fit column widths
    ws['!cols'] = columns.map((c, i) => {
        const maxLen = Math.max(
            c.header.length,
            ...rows.map(r => String(r[i] ?? '').length)
        );
        return { wch: Math.min(maxLen + 2, 50) };
    });

    // Set RTL for Arabic content
    ws['!dir'] = 'rtl';

    // Create workbook and download
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
    XLSX.writeFile(wb, `${filename}.xlsx`);
};
